import { PRIVATE_PARTNER_COMPANY_LABEL } from './constants';

export const getDisplayedCompanyName = paramValues => {
  const {
    company_name_1: companyNameFirst,
    company_name_2,
    company_name_3,
    company_name_4,
    company_name_5,
    nest_no,
    private_partner_company_flag,
  } = paramValues;
  let companyNameOther = '';
  if (nest_no) {
    switch (nest_no) {
      case 2:
        companyNameOther = company_name_2; // 2次協力会社取得
        break;
      case 3:
        companyNameOther = company_name_3; // 3次協力会社取得
        break;
      case 4:
        companyNameOther = company_name_4; // 4次協力会社取得
        break;
      case 5:
        companyNameOther = company_name_5; // 5次協力会社取得
        break;
      default:
        break;
    }
  }
  const bettoLabel = private_partner_company_flag
    ? PRIVATE_PARTNER_COMPANY_LABEL
    : '';
  return (
    companyNameFirst +
    (companyNameOther ? `（${companyNameOther}）` : '') +
    bettoLabel
  );
};



// WEBPACK FOOTER //
// ./src/utilities/getDisplayedCompanyName.js